import React from "react";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./NavbarComponent.css";

function NavbarComponent() {
  const navigate = useNavigate();

  return (
    <Navbar bg="white" expand="lg" fixed="top" className="shadow-sm py-3">
      <Container>
        <Navbar.Brand
          className="d-flex align-items-center logo-section"
          onClick={() => navigate("/")}>
          <img
            src="/images/One_place_solar_logo.png"
            alt="logo"
            className="logo-icon"/>
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-center">
            <Nav.Link
              className="nav-link-custom"
              onClick={() => navigate("/")}>
              Home
            </Nav.Link>

            <Nav.Link
              className="nav-link-custom"
              onClick={() => navigate("/demo")}>
              Demo
            </Nav.Link>

            <Button
              onClick={() => navigate("/register")}
              variant="outline-primary"
              className="me-3 signup-btn">
              Signup
            </Button>

            <Button
              onClick={() => navigate("/login")}
              className="login-btn">
              Login
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavbarComponent;